import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_7 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg.", -1)
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex align-items-center mb-2" }
const _hoisted_15 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_16 = { href: "#" }
const _hoisted_17 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_18 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_19 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_20 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_21 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_22 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Settings ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  ref: "profilePictureRef",
                  class: "image-input-wrapper w-125px h-125px",
                  style: _normalizeStyle(`background-image: ${
                  _ctx.newImageAdded
                    ? `url(${_ctx.tempImage})`
                    : `url(${
                        _ctx.user.profileImage ?? require('@/assets/img/blank.png')
                      })`
                }`)
                }, null, 4),
                _createElementVNode("label", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("input", {
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleImageUpload($event))),
                    type: "file",
                    name: "avatar",
                    accept: ".png, .jpg, .jpeg"
                  }, null, 32),
                  _hoisted_9
                ])
              ]),
              _hoisted_10
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("a", _hoisted_15, _toDisplayString(`${_ctx.op.get(_ctx.user, "firstName", "")} ${_ctx.op.get(
                      _ctx.user,
                      "lastName",
                      ""
                    )}`), 1),
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("a", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.op.get(_ctx.user, "jobTitle", "")), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: "/crafted/account/settings",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}